import { Component } from '@angular/core';

@Component({
  selector: 'app-subscribed',
  templateUrl: './subscribed.component.html',
  styleUrls: ['./subscribed.component.scss'],
})
export class SubscribedComponent {}
